import { useState } from 'react';
import { z } from 'zod';

import {
  optionalStringZod,
  requiredObjectZod,
  requiredStringZod,
} from '../../tailwind-ui';
import { doCRMRequest } from '../utils/request';

export type HandleSubmitNewsletterForm = z.infer<typeof schema>;

export const schema = requiredObjectZod({
  educational: z.boolean(),
  email: requiredStringZod().email('Invalid email address'),
  name: optionalStringZod(),
});

export const defaultValues: HandleSubmitNewsletterForm = {
  educational: true,
  email: '',
};

export async function handleSubmitNewsletterForm(
  values: HandleSubmitNewsletterForm,
) {
  const { educational, email, name } = values;

  const response = await doCRMRequest(
    educational ? 'educational' : 'newsletter',
    { email, name },
  );

  if (response.ok) {
    return;
  }

  throw new Error(
    `An error occurred while submitting the form. status: ${!response.ok && response.status}`,
  );
}

export function useHandleNewsletterForm() {
  const [isRequestOk, setIsRequestOk] = useState(false);

  async function handleSubmit(values: HandleSubmitNewsletterForm) {
    try {
      await handleSubmitNewsletterForm(values);
      setIsRequestOk(true);
    } catch (error: unknown) {
      // Capture the error to send it to Sentry. And keep it for FormRHF to show it.
      reportError(error);
      throw error;
    }
  }

  return { isRequestOk, handleSubmit, setIsRequestOk };
}
